<gen-carousel
  *ngIf="itemsWithTabs$ | async as items"
  [title]="title$ | async"
  [tabReferences]="items"
  [template]="carouselItem"
  [viewAllLink]="viewAllLink$ | async"
  itemWidth="285px"
>
</gen-carousel>

<ng-template #carouselItem let-item="item">
  <gen-product-grid-item [tooltipMessage]="tooltipMessage" [phoneNumberOrEmail]="phoneOrEmail" [product]="item" [gaListName]="gaListName"></gen-product-grid-item>
</ng-template>
